/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable react/no-unsafe */
import { Component } from 'react'

import { Swipeable } from '@skytech/ui'
// @ts-ignore
import sort, { ASC } from 'sort-array-objects'

import { getSalaryDeductionList } from '@/api/salaryDeduction'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { withNavigation } from '@/hocs/withNavigation'
import { getMonthName } from '@/util/formatters/dates'

import { Translation } from '../i18n/Translation'

import { SalaryDeductionApplication } from './SalaryDeductionApplication'
import SalaryDeductionListItem from './SalaryDeductionListItem'
import SalaryDeductionSubServices from './SalaryDeductionSubServices'

import './style/salary-deduction-list.scss'

class SalaryDeductionList extends Component<any> {
  // @ts-ignore
  constructor(props) {
    super(props)
    this.state = {
      invoiceRows: [],
      CDRs: [],
      contentServices: [],
      visible: false,
      loading: false,
      animate: true,
      invoice: null,
      hasDeduction: false,
      freeAllowanceLock: 0,
      applicationMode: false,
      applicationPost: null,
    }
  }

  componentDidMount = () => {
    if (this.props.active) {
      this.loadInvoice()
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps = (nextProps: any) => {
    if (nextProps.active) {
      this.loadInvoice()
    }
  }

  loadInvoice() {
    const invoice = this.props.currentInvoice
    this.setState({
      invoiceRows: [],
      visible: true,
      loading: true,
      animate: true,
    })
    getSalaryDeductionList({ phoneNumber: this.props.user.code, invoiceId: invoice.id })
      .then(result => {
        // @ts-ignore
        let posts = []
        let salaryDeduction = 0
        let freeAllowanceGranted = 0
        let freeAllowanceAmount = 0
        let i = 0
        let counterPostId = -1
        // @ts-ignore
        result.invoiceContent.forEach(item => {
          if (
            item.sda_id ||
            (item.salary_deduction_amount && item.salary_deduction_amount !== 0) ||
            (item.pending_salary_deduction_amount && item.pending_salary_deduction_amount !== 0)
          ) {
            // eslint-disable-next-line eqeqeq
            if (item.sda_status == null) item.sda_status = -1
            posts.push(item)
            salaryDeduction += item.salary_deduction_amount + item.salary_deduction_vat
            if (item.p_id === 2141) {
              freeAllowanceGranted += item.salary_deduction_amount
              counterPostId = i
            }
            if (item.free_allowance_participant) {
              freeAllowanceAmount += item.salary_deduction_amount
            }
            i++
          }
        })
        // @ts-ignore
        let counterPost = posts[counterPostId]
        if (counterPost && salaryDeduction < 0) {
          counterPost.salary_deduction_amount -= salaryDeduction
        }
        this.setState({
          // @ts-ignore
          invoiceRows: sort([...posts], ['sda_status', 'amount'], ASC),
          // @ts-ignore
          CDRs: result.CDRs,
          // @ts-ignore
          contentServices: result.contentServices,
          loading: false,
          invoice: invoice,
          hasDeduction: salaryDeduction > 0,
          freeAllowanceLock: freeAllowanceGranted + freeAllowanceAmount,
        })
      })
      .catch(() => {})
  }

  // @ts-ignore
  updatePost = post => {
    // @ts-ignore
    const posts = this.state.invoiceRows
    const id = post.irId
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < posts.length; i++) {
      if (id === posts[i].id) {
        posts[i].sda_status = post.status
        posts[i].sda_amount = post.amount
        posts[i].sda_vat = post.vat
        posts[i].sda_comment = post.comment
      }
    }
    this.setState({
      invoiceRows: [...posts],
    })
  }

  getPosts() {
    let sda_status = -1
    let headers = 0
    // @ts-ignore
    let posts = this.state.invoiceRows
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < posts.length; i++) {
      // @ts-ignore
      if (posts[i].free_allowance_participant && this.state.freeAllowanceLock === 0) {
        posts[i].sda_status = 1
      }
    }
    let sortedPosts = sort([...posts], ['sda_status', 'amount'], ASC)
    // @ts-ignore
    return sortedPosts.map(item => {
      let header = item.sda_status !== sda_status
      sda_status = item.sda_status
      if (header) headers++
      return (
        <SalaryDeductionListItem
          key={item.id}
          post={item}
          // @ts-ignore
          list={this}
          isHeaderVisible={header}
          headerNumber={headers}
          // @ts-ignore
          freeAllowanceLock={this.state.freeAllowanceLock}
          // @ts-ignore
          CDRs={this.state.CDRs}
          // @ts-ignore
          contentServices={this.state.contentServices}
          deadLinePassed={this.props.deadline.passed}
          // @ts-ignore
          hasDeduction={this.state.hasDeduction}
          setUpApplication={this.setupApplication}
        />
      )
    })
  }
  // @ts-ignore
  setupApplication = invoiceRow => {
    this.setState({
      applicationPost: { ...invoiceRow },
      applicationMode: true,
    })
  }

  closeApplication = () => {
    this.setState({
      applicationMode: false,
    })
  }

  hide = () => {
    this.props.navigate('/dashboard/' + this.props.offset)
    this.setState({
      visible: false,
      applicationMode: false,
    })
  }
  // @ts-ignore
  getHeader = invoice => (
    <div className="invoice-header">
      <h1>{invoice ? <Translation id={getMonthName(invoice.date)} /> : ''}</h1>
      <h2>{invoice ? 'Faktnr: ' + invoice.invoice_no : ''}</h2>
    </div>
  )

  render() {
    const { subscriptionServices } = this.props
    // @ts-ignore
    const { invoice } = this.state

    let classNames = [this.props.active ? 'is-visible' : '']
    let sumItemClassName = 'list_item '
    let sumHeaderClassName = 'type_header '
    // @ts-ignore
    sumItemClassName += this.state.applicationMode ? '' : 'is-visible'
    // @ts-ignore
    sumHeaderClassName += this.state.applicationMode ? '' : 'is-visible'

    // @ts-ignore
    if (this.state.animate) {
      classNames.push('animate')
    }

    // @ts-ignore
    function note(hasDeduction) {
      if (hasDeduction) return null
      return (
        <div className="listHeader">
          <Translation id="Denne fakturaen har ikke lønnstrekk, så du kan ikke gjøre om poster fra privat til jobb." />
        </div>
      )
    }

    const fixedSalaryDeduction = !invoice
      ? 0
      : subscriptionServices
          // @ts-ignore
          .filter(service => new Date(service.activated) < new Date(this.state.invoice.date))
          // @ts-ignore
          .reduce((acc, cur) => acc + cur.price, 0)

    // @ts-ignore
    const calculateTotalAmount = (invoice, fixedSalaryDeduction) => {
      if (!invoice) return 0

      let totalAmount =
        invoice.salary_deduction_amount + invoice.salary_deduction_vat + fixedSalaryDeduction

      // Threat negative values as 0
      if (totalAmount < 0) {
        totalAmount = 0
      }

      return totalAmount
    }

    const content = (
      <div className="content-wrapper">
        {/* @ts-ignore */}
        {this.getHeader(this.state.invoice)}
        {/* @ts-ignore */}
        {note(this.state.hasDeduction || this.state.applicationMode)}
        <div className="posts">
          {this.getPosts()}

          <SalaryDeductionSubServices invoice={invoice} />

          <div className="post" key={0}>
            <div className={sumHeaderClassName}>
              <Translation id="Sum" />
            </div>
            <div className={sumItemClassName}>
              <div className="sda sum">
                <FormattedNumberWithCurrency
                  amount={calculateTotalAmount(invoice, fixedSalaryDeduction)}
                  precision={2}
                />
              </div>
              <div className="prod sum">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    )

    const loader = (
      <div className="invoice-header">
        <div className="loader dark" />
      </div>
    )

    // todo: replace with a hook when possible
    const whiteLabel = localStorage.getItem('org')

    return (
      <div>
        <Swipeable
          id="salary-deduction-list"
          className={[...classNames, whiteLabel].join(' ')}
          // @ts-ignore
          onSwipedRight={!this.state.applicationMode ? this.hide : undefined}
        >
          {/* @ts-ignore  */}
          {this.state.loading ? loader : content}
        </Swipeable>

        <SalaryDeductionApplication
          // @ts-ignore
          invoice={this.state.invoice}
          // @ts-ignore
          applicationPost={this.state.applicationPost}
          // @ts-ignore
          applicationMode={this.props.active && this.state.applicationMode}
          deadLinePassed={this.props.deadline ? this.props.deadline.passed : undefined}
          // @ts-ignore
          contentServices={this.state.contentServices}
          // @ts-ignore
          hasDeduction={this.state.hasDeduction}
          // @ts-ignore
          freeAllowanceLock={this.state.freeAllowanceLock}
          // @ts-ignore
          CDRs={this.state.CDRs}
          closeApplication={this.closeApplication}
          updatePost={this.updatePost}
          getHeader={this.getHeader}
        />
      </div>
    )
  }
}

export default withNavigation(SalaryDeductionList)
